export default {
  id: "departmentComparison",
  name: "",
  description: "",
  report: {
    name: "Department Comparison",
    chartType: "",
    template: "department-comparison",
    config: {
      dataType: "single",
      dataSet: "Department",
      measures: [],
      dimensions: [],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: true,
      filterDateRange: true,
    },
  },
};
